export default {
  authorized: state => state.authorized,
};



// WEBPACK FOOTER //
// ./src/store/drivers/getters.js